"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.beefyfinance = void 0;
var cowllector = '0xd529b1894491a0a26B18939274ae8ede93E81dbA';
exports.beefyfinance = {
    strategyOwner: '0x6d28afD25a1FBC5409B1BeFFf6AEfEEe2902D89F',
    vaultOwner: '0x4E2a43a0Bf6480ee8359b7eAE244A9fBe9862Cdf',
    keeper: '0x10aee6B5594942433e7Fc2783598c979B030eF3D',
    rewarder: cowllector,
    treasurer: '0x3Eb7fB70C03eC4AEEC97C6C6C1B59B014600b7F7',
    launchpoolOwner: cowllector,
    rewardPool: '0x5f7347fedfD0b374e8CE8ed19Fc839F59FB59a3B',
    treasury: '0xf4859A3f36fBcA24BF8299bf56359fB441b03034',
    beefyFeeRecipient: '0x183D1aaEf1a86De6f16B2737c30eF94a6d2A9308',
    multicall: '0x2776CF9B6E2Fa7B33A37139C3CB1ee362Ff0356e',
    bifiMaxiStrategy: '0xfdF1088F5B9Bd338D5197aCfB00b468f04bCC374',
};
